import { passwordReset } from "@api/resetPassword";
import { ErrorModal, SuccessModal } from "@components";
import { Button, ConfirmationModal, Text } from "@pentabd/ui";
import { Dispatch, SetStateAction, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

export const PasswordReset = ({
  employeeId,
  setSelectedEmployeeId,
}: {
  employeeId: number | undefined;
  setSelectedEmployeeId: Dispatch<SetStateAction<number | undefined>>;
}) => {
  const { t } = useTranslation();
  const { reset } = useFormContext();

  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState<boolean>(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState<boolean>(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState<boolean>(false);

  const handleResetPassword = async (_e: any) => {
    try {
      if (employeeId) {
        const response = await passwordReset(employeeId);
        if (response) {
          setIsSuccessModalOpen(true);
        } else {
          setIsErrorModalOpen(true);
        }
      }
    } catch (error) {
      setIsErrorModalOpen(true);
    } finally {
      setIsConfirmModalOpen(false);
    }
  };

  // MODAL SECTION
  const closeErrorModal = () => setIsErrorModalOpen(false);
  const createSuccessAction = () => {
    setIsSuccessModalOpen(false);
    reset();
    setSelectedEmployeeId(undefined);
  };

  const openConfirmModal = () => setIsConfirmModalOpen(true);

  return (
    <div>
      {/* MODAL SECTION */}
      <>
        <SuccessModal
          isModalOpen={isSuccessModalOpen}
          action={createSuccessAction}
        />
        <ErrorModal
          isModalOpen={isErrorModalOpen}
          closeModal={closeErrorModal}
        />
        <ConfirmationModal
          isOpen={isConfirmModalOpen}
          closeAble={true}
          onClose={() => setIsConfirmModalOpen(false)}
          title={t("HRM_SETTINGS.PASSWORD_RESET.RESET_MESSAGE")}
          confirmButton={{
            onClick: handleResetPassword,
            label: t("HRM_SETTINGS.PASSWORD_RESET.BUTTON"),
            htmlType: "button",
            fill: "fill",
            type: "primary",
            size: "sm",
          }}
          cancelButton={{
            onClick: () => setIsConfirmModalOpen(false),
            label: t("HRM_SETTINGS.PASSWORD_RESET.CANCEL_BUTTON"),
            htmlType: "button",
            fill: "outline",
            type: "danger",
            size: "sm",
          }}
        />
      </>
      {/* MODAL SECTION */}
      <div className="row p-10">
        <div className="col-lg-3">
          <Text weight="semibold" color="title" size="sm">
            {t("HRM_SETTINGS.PASSWORD_RESET.HEADER")}
          </Text>
        </div>
        <div className="col-lg-7">
          <Button
            fill="fill"
            type="primary"
            htmlType="submit"
            onClick={openConfirmModal}
            disabled={!employeeId}
          >
            {t("HRM_SETTINGS.PASSWORD_RESET.BUTTON")}
          </Button>
        </div>
      </div>
    </div>
  );
};
